module.exports = __webpack_public_path__ + "src/components/@atoms/CaFooter/images/10moZ92.svg";